/**
 * MaskedLocation - Shows coordinates with masked seconds and eye toggle
 */

import React, { useState } from 'react';
import { Text, HStack, IconButton } from '@chakra-ui/react';
import { Eye, EyeOff } from 'lucide-react';
import { maskCoordinateSeconds } from './chartInfoUtils';

export const MaskedLocation: React.FC<{ location: string }> = ({ location }) => {
    const [showFull, setShowFull] = useState(false);

    const displayValue = showFull ? location : maskCoordinateSeconds(location);

    return (
        <HStack spacing={1} display="inline-flex">
            <Text as="span" fontSize="sm">{displayValue}</Text>
            <IconButton
                aria-label={showFull ? 'Hide full coordinates' : 'Show full coordinates'}
                icon={showFull ? <EyeOff size={14} /> : <Eye size={14} />}
                size="xs"
                variant="ghost"
                minW={5}
                h={5}
                onClick={(e) => { e.stopPropagation(); setShowFull(!showFull); }}
                color="gray.500"
                _hover={{ color: 'gray.700' }}
            />
        </HStack>
    );
};
